var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSendIcon = function SvgSendIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0389,
    cy: 35.2986,
    r: 34.5193,
    fill: "#DFE0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0684 21.3325C27.3359 21.3325 21.0449 27.6235 21.0449 35.356C21.0449 43.0885 27.3359 49.3795 35.0684 49.3795C42.8009 49.3795 49.0919 43.0885 49.0919 35.356C49.0919 27.6235 42.8009 21.3325 35.0684 21.3325ZM42.3667 30.6561L33.3054 41.4434C33.206 41.5618 33.0823 41.6574 32.9427 41.7239C32.8031 41.7903 32.6509 41.8259 32.4963 41.8284H32.4781C32.3269 41.8283 32.1774 41.7965 32.0393 41.7349C31.9012 41.6734 31.7776 41.5835 31.6765 41.4711L27.793 37.1561C27.6944 37.0515 27.6177 36.9283 27.5674 36.7936C27.5171 36.6589 27.4942 36.5155 27.5001 36.3719C27.506 36.2282 27.5406 36.0872 27.6017 35.9571C27.6629 35.827 27.7495 35.7104 27.8563 35.6143C27.9632 35.5181 28.0882 35.4443 28.224 35.3971C28.3598 35.3499 28.5037 35.3304 28.6472 35.3396C28.7906 35.3488 28.9308 35.3867 29.0595 35.4508C29.1881 35.515 29.3026 35.6043 29.3963 35.7133L32.4498 39.1059L40.7149 29.2686C40.9003 29.0543 41.1626 28.9215 41.4451 28.899C41.7276 28.8765 42.0076 28.966 42.2246 29.1483C42.4416 29.3306 42.5781 29.5909 42.6047 29.8731C42.6313 30.1552 42.5458 30.4365 42.3667 30.6561Z",
    fill: "#A9ADC4"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSendIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sendIcon.9f78a5a8a134342355bbf28645321a29.svg";